function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { StimulusUse } from '../stimulus-use';
export var UseMutation = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseMutation, _StimulusUse);

  var _super = _createSuper(UseMutation);

  function UseMutation(controller) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseMutation);

    _this = _super.call(this, controller, options);

    _this.observe = function () {
      try {
        _this.observer.observe(_this.targetElement, _this.options);
      } catch (error) {
        _this.controller.application.handleError(error, 'At a minimum, one of childList, attributes, and/or characterData must be true', {});
      }
    };

    _this.unobserve = function () {
      _this.observer.disconnect();
    };

    _this.mutation = function (entries) {
      _this.call('mutate', entries);

      _this.log('mutate', {
        entries: entries
      });

      _this.dispatch('mutate', {
        entries: entries
      });
    };

    _this.targetElement = (options === null || options === void 0 ? void 0 : options.element) || controller.element;
    _this.controller = controller;
    _this.options = options;
    _this.observer = new MutationObserver(_this.mutation);

    _this.enhanceController();

    _this.observe();

    return _this;
  }

  _createClass(UseMutation, [{
    key: "enhanceController",
    value: function enhanceController() {
      var _this2 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this2.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseMutation;
}(StimulusUse);
export var useMutation = function useMutation(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseMutation(controller, options);
  return [observer.observe, observer.unobserve];
};